import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const FormInput = ({
  label,
  type = "text",
  value,
  onChange,
  placeholder = "",
  icon = null,
  required = true,
  id,
  className = "mb-3",
  extraElement = null,
  inputStyle = {},
  ...restProps
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";
  const actualType = isPassword ? (showPassword ? "text" : "password") : type;

  const fieldId = id || (label ? label.toLowerCase().replace(/\s+/g, "-") : undefined);

  return (
    <div className={`form-group ${className}`}>
      {label && <label htmlFor={fieldId}>{label}</label>}
      <div className="input-with-icon" style={{ position: "relative" }}>
        {icon && (
          <span
            style={{
              position: "absolute",
              left: "14px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#A3A3A3",
              zIndex: 2,
            }}
          >
            {icon}
          </span>
        )}
        <input
          id={fieldId}
          type={actualType}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          className="form-control custom-input"
          style={{
            paddingLeft: icon ? "42px" : "16px",
            paddingRight: isPassword ? "45px" : extraElement ? "130px" : "16px",
            backgroundColor: "#225750",
            borderColor: "rgba(111, 230, 184, 0.25)",
            color: "#ffffff",
            ...inputStyle,
          }}
          {...restProps}
        />
        {isPassword && (
          <span
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#A3A3A3",
              zIndex: 3,
            }}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
        )}
        {extraElement && (
          <div
            style={{
              position: "absolute",
              right: "6px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 3,
              display: "flex",
              alignItems: "center",
            }}
          >
            {extraElement}
          </div>
        )}
      </div>
    </div>
  );
};

export default FormInput;
